import { HIDE_MODAL as a, SET_MODAL_PRIMARY_BTN_DISABLED as r, SET_MODAL_OPTIONS as i } from "./types.js";
const n = {
  body: [""],
  cancelFunction: void 0,
  cancelLabel: "Ok",
  confirm: !1,
  handlerFunction: void 0,
  exitFunction: void 0,
  primaryLabel: "Confirm",
  showModal: !1,
  status: "",
  title: "",
  url: ""
};
function c(e = { ...n }, o) {
  switch (o.type) {
    case i:
      return {
        ...e,
        ...o.payload
      };
    case r:
      return {
        ...e,
        primaryDisabled: o.payload
      };
    case a:
      return e.showModal ? { ...n } : e;
    default:
      return e;
  }
}
export {
  c as modalReducer
};
//# sourceMappingURL=reducers.js.map
